import { Injectable } from '@angular/core';
import * as mixpanel from 'mixpanel-browser';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';
import { User } from '../interfaces/user';

@Injectable({
  providedIn: 'root',
})
export class MixpanelService {
  isInitialized: boolean;
  constructor(private authService: AuthService) {}

  async init() {
    try {
      // Zeus's Mixpanel project uses EU data residency
      await mixpanel.init(environment.mixpanel.token, { api_host: 'https://api-eu.mixpanel.com' });
      this.isInitialized = true;
    } catch (err) {
      this.isInitialized = false;
    }
  }

  // Analytics failures must never surface as an error in the calling business flow.
  async trackEvent(eventName: string, param: any) {
    try {
      if (!this.isInitialized) await this.init();
      if (this.isInitialized) await mixpanel.track(eventName, param);
    } catch {
      /* swallowed so tracking cannot fail the user's action */
    }
  }

  async alias(user: User) {
    if (!this.isInitialized) await this.init();
    if (this.isInitialized) await mixpanel.alias(user.id);
  }
  async identify() {
    if (!this.isInitialized) await this.init();
    if (!this.isInitialized) return;
    const user = this.authService.getUser();
    const tenant = this.authService.getTenant();
    mixpanel.identify(user.id);
    mixpanel.people.set({
      firstName: user.firstName,
      lastName: user.lastName,
      $email: user.email,
      'Company Name': tenant.name,
      'Account Type': tenant.type,
      'Is Super Admin': tenant.isAdmin || user.isAdmin,
    });
  }
  async reset() {
    await mixpanel.reset();
  }
}
